import { Select } from "@mantine/core";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { TodoUser } from "../../Todos.types";
import type { TodoTableTodo } from "../TodoTable";

function getResponsibleColumn(
  users: Array<TodoUser>,
  onChangeResponsible: (responsibleId: number | null, todoId: number) => void
): MRT_ColumnDef<TodoTableTodo> {
  return {
    header: "Verantwortlich",
    accessorKey: "responsible",
    accessorFn: (todo: TodoTableTodo) => {
      const responsibleUser = users.find(
        (user) => user.id === todo.responsible
      );
      return responsibleUser ? responsibleUser.name : null;
    },
    filterVariant: "multi-select",
    mantineFilterMultiSelectProps: {
      data: [
        { value: "", label: "(leer)" },
        ...users
          .map((user) => ({
            value: user.id.toString(),
            label: user.name
          }))
          .sort((a, b) => a.label.localeCompare(b.label))
      ]
    },
    filterFn: (row, id, filterValues) => {
      if (filterValues.length === 0) {
        return true;
      }
      if (filterValues.includes("(leer)") && row.getValue(id) === null) {
        return true;
      }
      const value = row.getValue(id);
      return value ? filterValues.includes(value.toString()) : false;
    },
    Cell: ({ row }) => (
      <Select
        data={[
          { value: "", label: "---" },
          ...users
            .map((user) => ({
              value: user.id.toString(),
              label: user.name
            }))
            .sort((a, b) => a.label.localeCompare(b.label))
        ]}
        value={row.original.responsible?.toString()}
        onChange={(newResponsibleId) =>
          onChangeResponsible(
            newResponsibleId === null || newResponsibleId === ""
              ? null
              : parseInt(newResponsibleId, 10),
            row.original.id
          )
        }
      />
    )
  };
}

export { getResponsibleColumn };
